export default "__VITE_ASSET__558cf872__"